










































































import StartEnd from '@/enums/StartEnd'
import { computed, defineComponent, ref, unref, PropType, watch } from '@nuxtjs/composition-api'

import SearchBarFieldDate from '@/components/search-bar/SearchBarFieldDate.vue'
import SearchBarFieldDateHour from '@/components/search-bar/SearchBarFieldDateHour.vue'
import DatePicker from '@/components/date-picker/DatePicker.vue'
import DatePickerBody from '@/components/date-picker/DatePickerBody.vue'

import DateHourRange from '@/classes/DateHourRange'
import DateHour from '@/classes/DateHour'

import { SeatsValue } from '@/composables/use-seats'
import useDateHourRange from '@/composables/use-date-hour-range'
import useI18n from '@/composables/use-i18n'
import { whenever } from '@vueuse/shared'
import Store from '@/classes/Store'

import { Options as PopperOptions } from '@popperjs/core'

export default defineComponent({
  props: {
    hideLabel: {
      type: Boolean,
      default: false,
    },
    hideTabs: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dateHourRange: {
      type: DateHourRange as PropType<DateHourRange>,
      default: (): DateHourRange => new DateHourRange(),
    },
    seats: {
      type: String as PropType<SeatsValue>,
      default: null,
    },
    type: {
      type: String,
      default: 'car',
    },
    locationShortname: {
      type: String,
      default: 'TW',
    },
    store: {
      type: Object as PropType<Store>,
      default: null,
    },
    datePickerMenuOptions: {
      type: Object as PropType<PopperOptions>,
      default: () => ({
        placement: 'bottom-start',
        strategy: 'absolute',
        modifiers: [{ name: 'offset', options: { offset: [-16, 20] } }],
      }),
    },
  },
  setup (props, { emit }) {
    const i18n = useI18n()

    const proxyType = computed({
      get: () => props.type,
      set: value => emit('update:type', value),
    })

    // DateHour
    const proxyDateHourRange = computed({
      get: () => props.dateHourRange,
      set: value => emit('update:dateHourRange', value),
    })
    const datePicker = ref<InstanceType<typeof DatePicker> | null>(null)
    const startField = ref<InstanceType<typeof SearchBarFieldDateHour> | null>(null)
    const endField = ref<InstanceType<typeof SearchBarFieldDateHour> | null>(null)
    const startDateField = ref<InstanceType<typeof SearchBarFieldDate> | null>(null)
    const endDateField = ref<InstanceType<typeof SearchBarFieldDate> | null>(null)
    const datePickerBody = ref<InstanceType<typeof DatePickerBody> | null>(null)

    const activators = computed(() => [startDateField.value?.$el, endDateField.value?.$el])

    const showDatePicker = (type: StartEnd = StartEnd.END) => {
      datePicker.value?.show(type, unref(proxyDateHourRange))
    }

    const {
      setRange,
      setStart,
      setEnd,
      selectingType,
      setSelectingType,
      selectingValue,
      setSelectingValue,
    } = useDateHourRange(proxyDateHourRange)
    /** 強迫讓props變時trigger選擇器值也變 */
    watch(() => props.dateHourRange.clone(), (val) => {
      setSelectingValue({ start: val.start.date!, end: val.end.date! })
    })

    // Seats
    const proxySeats = computed({
      get: () => props.seats,
      set: value => emit('update:seats', value),
    })
    const fieldBind = computed(() => ({
      hideLabel: props.hideLabel,
    }))

    const wrapperClass = computed(() => ({
      border: props.outlined,
      'shadow-y': !props.outlined,
    }))

    const formClass = computed(() => ({
      'shadow-y': !props.outlined,
    }))

    // Submit
    const isRangeValid = computed(() => props.dateHourRange.isValid)
    const isRangeDateEmpty = computed(() => props.dateHourRange.isDateEmpty)
    const isRangeSame = computed(() => props.dateHourRange.isDateHourSame)
    const isRangeStartAfterEnd = computed(() => props.dateHourRange.isStartAfterEnd)

    const hourErrorMessage = ref<string | null>(null)

    const submit = () => {
      if (isRangeDateEmpty.value) {
        showDatePicker()
      } else if (isRangeSame.value || isRangeStartAfterEnd.value) {
        hourErrorMessage.value = String(i18n.t('message.sameDateHourRange'))
      } else {
        emit('submit')
      }
    }

    // 當起訖時間不一樣就清除錯誤訊息
    whenever(
      () => !(isRangeSame.value || isRangeStartAfterEnd.value),
      () => { hourErrorMessage.value = null }
    )

    // 選擇起訖時間區間
    const startHourRange = computed(() => {
      if (props.dateHourRange && props.store && props.store.getHourRange) {
        if (props.dateHourRange.start) {
          return props.store.getHourRange(props.dateHourRange.start.date?.toDate().getDay())
        }
      }
      return DateHour.hourRange
    })
    const endHourRange = computed(() => {
      if (props.dateHourRange && props.store && props.store.getHourRange) {
        if (props.dateHourRange.end) {
          return props.store.getHourRange(props.dateHourRange.end.date?.toDate().getDay())
        }
      }
      return DateHour.hourRange
    })

    watch(datePickerBody, (val) => {
      emit('update:datePickerBody', val)
    })

    return {
      StartEnd,

      proxyType,

      proxyDateHourRange,
      setRange,
      setStart,
      setEnd,
      datePicker,
      showDatePicker,

      proxySeats,
      fieldBind,
      startField,
      endField,
      activators,
      selectingType,
      selectingValue,
      setSelectingValue,
      setSelectingType,
      wrapperClass,
      formClass,

      submit,
      isRangeValid,

      hourErrorMessage,

      startHourRange,
      endHourRange,

      startDateField,
      endDateField,

      datePickerBody,
    }
  },
})
